import { useLingui } from '@lingui/react'
import type { FC } from 'react'

import type { AverageRatingRangeRefinement } from 'shared/utils/algolia/types'
import IconCaretRight from 'views/components/atoms/Icon/IconCaretRight'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import Modal from 'views/components/molecules/Modal'
import ModalShowButton from 'views/components/molecules/ModalShowButton'
import { ProductFilterV1FilterCounter } from 'views/components/organisms/AlgoliaInstantSearch/ProductFilterV1/ProductFilterV1FilterCounter/ProductFilterV1FilterCounter'

import { ProductFilterV1StarRatingSlider } from './ProductFilterV1StarRatingSlider'
import './ProductFilterV1StarRating.scss'

const modalId = 'product-filter-v1-star-rating'

export const ProductFilterV1StarRating: FC<{
  averageRating: AverageRatingRangeRefinement
}> = ({ averageRating }) => {
  const { i18n } = useLingui()

  return (
    <div className="o-product-filter-v1-star-rating">
      {/* @ts-ignore */}
      <ModalShowButton
        component={ButtonAsLink}
        name={modalId}
        modalId={modalId}
        neutral
      >
        <div className="l-flex o-product-filter-v1-star-rating__item">
          <p className="u-no-margin u-color--dark l-flex__primary u-text-align--left u-font-weight--semi-bold o-product-filter-v1-star-rating__text">
            {i18n._('ratingOverview.headline')}{' '}
            <ProductFilterV1FilterCounter attribute="averageRating" />
          </p>
          <IconCaretRight />
        </div>
      </ModalShowButton>
      <Modal
        id={modalId}
        title={i18n._('ratingOverview.headline')}
        isClientSideControlled
        fullScreen
      >
        <ProductFilterV1StarRatingSlider
          label={i18n._('ratingOverview.headline')}
          attribute="averageRating"
          name="productFilter__ratingSlider"
          delimiterLabel={i18n._('general.label.until')}
          defaultValues={averageRating}
          modalId={modalId}
        />
      </Modal>
    </div>
  )
}
